import React from "react";
import styled from "styled-components";
import PeopleWebImg from "../../images/Borrower/PeopleEmotions_web.png";
import PeopleMobImg from "../../images/Borrower/PeopleEmotions_mobile.png";

const StyledWrapper = styled.section`
  margin: 0 25px 256px 29px;
  font-family: Inter;
  color: #000000;
  text-align: left;
  font-weight: 400;

  .PeopleMobImg {
    display: none;
  }
  .PeopleMobBck {
    display: none;
  }
  @media (max-width: 900px) {
    margin-bottom: 173px;
    .PeopleMobImg {
      display: block;
      z-index: 1;
    }
    .PeopleWebImg {
      display: none;
    }
    .PeopleWebBck {
      display: none;
    }
    .PeopleMobBck {
      position: absolute;
      bottom: -20px;
      display: block;
      width: 100%;
      border-radius: 0 0 40px 40px;
      background-color: #fff0ea;
      height: 250px;
    }
  }

  .wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    @media (max-width: 900px) {
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }

  .loan-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 57px;
    @media (max-width: 920px) {
      margin-left: 0;
    }
  }

  .loan-contaner {
    display: flex;
    margin-top: 30px;
    :last-child {
      margin-top: 45px;
    }
    @media (max-width: 900px) {
      justify-content: center;
      text-align: center;

      :first-child {
        margin-top: 0px;
      }
      :last-child {
        margin-top: 56px;
      }
    }
  }

  .loan-heading {
    font-size: 40px;
    font-weight: 700;
    line-height: 48.41px;

    @media (max-width: 900px) {
      font-size: 36px;
      font-weight: 700;
      line-height: 44.57px;
    }
  }
  .loan-sub-heading {
    font-size: 20px;
    line-height: 24.2px;
    @media (max-width: 900px) {
      br {
        content: "";
      }
    }
  }

  .loan-text {
    font-size: 16px;
    line-height: 20.8px;
    margin-top: 12px;

    @media (max-width: 900px) {
      margin: 16px 19px 0px 18px;
      font-size: 16px;
      line-height: 26.6px;
      br:last-child {
        content: "";
      }
    }
  }
  .loan-description {
    font-size: 24px;
    line-height: 29.05px;
    margin-top: 4px;
    font-weight: 700;

    @media (max-width: 900px) {
      margin-top: 4px;
      font-size: 24px;
      line-height: 29.05px;
      font-weight: 700;
    }
  }
  .image-container {
    position: relative;
    display: flex;
    justify-content: flex-start;
    z-index: 2;
    @media (max-width: 900px) {
      order: 1;
      margin-top: 0;
      justify-content: center;
      width: 100%;
    }
  }
  .background-container {
    z-index: 1;
    @media (max-width: 900px) {
      order: 2;
    }
  }
`;

const PersonalLoan = () => {
  return (
    <StyledWrapper>
      <div className="wrapper">
        <div className="image-container">
          <img className="PeopleWebImg" src={PeopleWebImg} alt="Emotion" />
          <img className="PeopleMobImg" src={PeopleMobImg} alt="Emotion" />
          <div className="PeopleMobBck"></div>
          <div className="PeopleWebBck"></div>
        </div>

        <div className="loan-container">
          <div className="loan-contaner">
            <div className="loan-text-container">
              <div className="loan-heading">Personal Loan</div>

              <div className="loan-text">
                Pay your monthly bills with ease.
                <br /> The quickest and easiest way to meet your lifestyle
                needs! <br />
                Set your goals and choose a repayment plan that works for YOU.
              </div>
            </div>
          </div>
          <div className="loan-contaner">
            <div className="loan-text-container">
              <div className="loan-sub-heading">Loan sizes</div>
              <div className="loan-description">₹50,000 to ₹7 lakhs</div>
            </div>
          </div>
          <div className="loan-contaner">
            <div className="loan-text-container">
              <div className="loan-sub-heading">Repayment time</div>
              <div className="loan-description">6 months to 72 months</div>
            </div>
          </div>
          <div className="loan-contaner">
            <div className="loan-text-container">
              <div className="loan-sub-heading">Flexible interest plans</div>
              <div className="loan-description">12% to 28%</div>
            </div>
          </div>
          <div className="loan-contaner">
            <div className="loan-text-container">
              <div className="loan-sub-heading">
                Already have <strong>a pre-approved offer</strong> from us?
                <br /> <strong>Jump the queue!</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledWrapper>
  );
};

export default PersonalLoan;
